import { render, staticRenderFns } from "./AffectedProjects.vue?vue&type=template&id=3511e218&"
import script from "./AffectedProjects.vue?vue&type=script&lang=js&"
export * from "./AffectedProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports